import iso3166 from 'iso-3166-2';

export const getStringAddress = ({
  addressLine1,
  city,
  stateOrProvince,
  postalCode,
  country,
}) => {
  let result = '';
  const addressLineCheck =
    addressLine1 && (addressLine1 !== '' || addressLine1 !== null);
  const cityCheck = city && (city !== '' || city !== null);
  const stateCheck =
    stateOrProvince && (stateOrProvince !== '' || stateOrProvince !== null);
  const postalCheck = postalCode && (postalCode !== '' || postalCode !== null);
  const countryCheck = country && (country !== '' || country !== null);

  if (addressLineCheck) result += addressLine1;

  if (cityCheck) result += (addressLineCheck ? ', ' : '') + city;

  if (stateCheck) {
    result +=
      (addressLineCheck || cityCheck ? ', ' : '') +
      iso3166.data[country]?.sub[`${country}-${stateOrProvince}`]?.name;
  }

  if (postalCheck) {
    result +=
      (addressLineCheck || cityCheck || stateCheck ? ', ' : '') + postalCode;
  }

  if (countryCheck) {
    result +=
      (addressLineCheck || cityCheck || stateCheck || postalCheck ? ', ' : '') +
      iso3166.data[country]?.name;
  }
  return result;
};
